import React from 'react';

function GraduationCap(props) {
  return (
    <svg
      className="c-GraduationCap"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.72 6.764L8.745 2.93a1.7 1.7 0 011.6 0l7.933 4.325c.267.15.434.425.434.734v5.341a.836.836 0 01-.834.834.836.836 0 01-.833-.834V8.405l-6.7 3.659c-.5.275-1.1.275-1.6 0L1.72 8.23a.84.84 0 010-1.466zm1.992 6.558V10.98l5.033 2.75c.5.275 1.1.275 1.6 0l5.033-2.75v2.342c0 .608-.333 1.175-.867 1.467l-4.166 2.275c-.5.274-1.1.274-1.6 0l-4.167-2.275a1.676 1.676 0 01-.867-1.467z"
        fill="#FBC91B"
      />
    </svg>
  );
}

export default GraduationCap;
